import React, { useState } from 'react';
import VariablesWindow from './VariablesWindow';

function BotCacheSection({ botId }) {
  const [abierta, setAbierta] = useState(false);

  return (
    <section className="config-card" aria-labelledby="cache-bot-titulo">
      <h3 id="cache-bot-titulo">Caché del bot</h3>
      <p className="config-card-hint">
        Variables compartidas por todos los chats de este bot. Caducan solas.
      </p>
      <button type="button" className="admin-btn secondary" onClick={() => setAbierta(true)}>
        Ver variables
      </button>
      {abierta ? (
        <VariablesWindow
          botId={botId}
          titulo="Caché del bot"
          onClose={() => setAbierta(false)}
        />
      ) : null}
    </section>
  );
}

export default BotCacheSection;
